import { map, get, omit } from 'lodash'

import { ACTION_TYPES } from 'store/common/constants/actionsTypes'
import { isOwnReducerAction, isOwnRemoveReducerAction } from 'utils/helpers/store/store'

export const storeEntityCreator =
  entityKey =>
  (state = {}, action = {}) => {
    const { keys, type, data = {} } = action
    const { id, entities } = data

    switch (type) {
      case ACTION_TYPES.ITEM_FETCH_SUCCESS:
      case ACTION_TYPES.LIST_FETCH_SUCCESS: {
        const entitiesIdsToUpdate = Object.keys(get(entities, entityKey, {})) || []
        const entitiesUpdated = {}

        if (!isOwnReducerAction(entityKey, entities)) {
          return state
        }

        map(entitiesIdsToUpdate, idToUpdate => {
          entitiesUpdated[idToUpdate] = {
            ...get(state, idToUpdate, {}),
            ...get(entities, `${entityKey}.${idToUpdate}`, {}),
          }
        })

        return {
          ...state,
          ...entitiesUpdated,
        }
      }

      case ACTION_TYPES.ITEM_REMOVE_SUCCESS: {
        if (!isOwnRemoveReducerAction(entityKey, keys)) {
          return state
        }

        return omit(state, [id])
      }

      default:
        return state
    }
  }
